import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { infrastructuresRepo } from '@/constants/providers';
import { DataWithPagination } from '@/shared/types';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AmountModel } from '../domain';
import { InfrastructureCostKey } from './types';

export const useGetInfrastructureCostAmountHistory = (
  costId: number,
  pageNumber?: number,
  filter?: string,
  sortBy?: string,
  sortOrder?: SortDirection,
  options?: UseQueryOptions<
    DataWithPagination<AmountModel[]>,
    any,
    DataWithPagination<AmountModel[]>
  >,
) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery<DataWithPagination<AmountModel[]>>(
    [
      ...InfrastructureCostKey.COST_HISTORY_PAGE(
        costId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
      currentSelectedTenant?.id,
    ],
    () =>
      infrastructuresRepo.getInfrastructureCostAmountHistory(
        costId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    options,
  );
};
